import { FC, ReactNode, useEffect, useRef, useState } from "react";
import styles from "./Accordion.module.scss";

interface AccordionContentProps {
  content: ReactNode;
}

const AccordionContent: FC<AccordionContentProps> = ({ content }) => {
  const [contentDomLoaded, setContentDomLoaded] = useState(false);
  const refContent = useRef<any>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setContentDomLoaded(true);
        });
      },
      {
        threshold: 0.5,
        rootMargin: "-10% 0% -35% 0px",
      }
    );

    observer.observe(refContent.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className={styles.accordion_content} ref={refContent}>
      {contentDomLoaded && !!content ? content : ""}
    </div>
  );
};

export default AccordionContent;
